var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-google-96 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8968 10.1232H20.1248V10.0834H11.4998V13.9167H16.9159C16.1257 16.1482 14.0025 17.7501 11.4998 17.7501C8.3244 17.7501 5.74984 15.1755 5.74984 12.0001C5.74984 8.82464 8.3244 6.25008 11.4998 6.25008C12.9656 6.25008 14.2991 6.80304 15.3145 7.70627L18.0251 4.99562C16.3135 3.40048 14.0241 2.41675 11.4998 2.41675C6.20744 2.41675 1.9165 6.70769 1.9165 12.0001C1.9165 17.2925 6.20744 21.5834 11.4998 21.5834C16.7922 21.5834 21.0832 17.2925 21.0832 12.0001C21.0832 11.3575 21.017 10.7303 20.8968 10.1232Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.02148 7.53952L6.17009 9.84862C7.02205 7.73933 9.08534 6.25008 11.4999 6.25008C12.9656 6.25008 14.2992 6.80304 15.3145 7.70627L18.0252 4.99562C16.3136 3.40048 14.0241 2.41675 11.4999 2.41675C7.8189 2.41675 4.62669 4.49489 3.02148 7.53952Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4998 21.5834C13.9752 21.5834 16.2244 20.6361 17.925 19.0956L14.9589 16.5857C13.9968 17.3145 12.8008 17.7501 11.4998 17.7501C9.0072 17.7501 6.89072 16.1607 6.09339 13.9426L2.96826 16.3504C4.5543 19.454 7.77526 21.5834 11.4998 21.5834Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.8969 10.123H20.125V10.0833H11.5V13.9166H16.916C16.5365 14.9885 15.847 15.9128 14.9577 16.586L14.9591 16.5851L17.9251 19.0949C17.7153 19.2856 21.0833 16.7916 21.0833 11.9999C21.0833 11.3574 21.0172 10.7301 20.8969 10.123Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBtn);
export default __webpack_public_path__ + "static/media/googleBtn.b9bb0a762f1eb2781ea775766edc922a.svg";
export { ForwardRef as ReactComponent };